import { reactive } from 'vue';
import { UsersService } from '@/api';
import { Debounce } from '@/common/debounce-decorator';

export type Filter = {
  source: string;
  filters: string[];
};

export class SmallFilterManagerModule {
  static Name = 'SmallFilterManagerModule';
  static StorageKey = 'smallFilters';

  public readonly items: Record<string, string[]> = {};
  loaded = false;

  async setFiltersBySource(source: string, items: string[], save: boolean = false) {
    this.items[source] = items;
    if (save) await this.saveUserFilters();
  }

  async loadUserFilters() {
    try {
      const smallFiltersData = await UsersService.usersMeDataRetrieve(SmallFilterManagerModule.StorageKey);
      const savedFields = JSON.parse(smallFiltersData?.value);
      Object.assign(this.items, savedFields);
    } catch (e) {
      console.warn('[users.service]:getFilters error', e);
    } finally {
      this.loaded = true;
    }
  }

  @Debounce(1000)
  async saveUserFilters() {
    try {
      await UsersService.usersMeDataUpdate('smallFilters', { key: SmallFilterManagerModule.StorageKey, value: JSON.stringify(this.items) ?? '' });
    } catch (e) {
      console.warn('[users.service]:saveFilters error', e);
    }
  }
}

export const smallFilterManagerModule = reactive(new SmallFilterManagerModule());
